<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Update Document Version</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<div class="pt-3 pb-2">
					<p class="font-weight-bold">
						Would you like to create a new version of this document?
					</p>
					<p class="info-text">Creating a new version will require {{ $term('employee', { plural: true }) }} who have already acknowledged this document to re-acknowledge it. <span style="font-style: italic;">This is the recommended approach.</span></p>
				</div>
				<v-switch v-model="result" label="Yes, update the version number"></v-switch>

				<v-alert :value="!result" color="warning" icon="warning" class="text-xs-left" outline
					>Changes will override the existing policy without creating a new version. {{ $term('employee', { plural: true, case: 'sentence' }) }} will not be notified, acknowledgements will remain valid, and no history of the previous file will be kept.</v-alert
				>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn :disabled="isConfirming" flat @click="onCancel">
					Cancel
				</v-btn>

				<v-btn :disabled="isConfirming" :loading="isConfirming" color="primary" flat @click="onConfirm">
					Save Changes
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			isConfirming: {
				type: Boolean,
				required: false
			},
			acknowledgedCount: {
				type: Number,
				required: false
			}
		},
		data() {
			return {
				result: true
			};
		},
		methods: {
			onConfirm() {
				this.$emit('onConfirm', this.result);
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
	}
</style>
